module.exports = __webpack_public_path__ + "static/img/service.e7796a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service.png
// module id = RS4J
// module chunks = 1